export default __webpack_public_path__ + "static/media/treasury.c1ea7fcf.svg";